'use client';

import { useEffect, useState } from 'react';
import { isSafari } from 'react-device-detect';

export function useIsSafari(): boolean {
  const [safari, setSafari] = useState(false);
  useEffect(() => {
    setSafari(isSafari);
  }, []);
  return safari;
}
